import { Label } from '../ui/label';
import { ColorPicker, useColor } from 'react-color-palette';

interface Props {
    value: string;
    onChange: (e: string) => void;
    label?: string;
}
export const ColorPaletteComponent = (props: Props) => {
    const { value, onChange, label } = props;
    const [color, setColor] = useColor(value);

    function getIntFromDecimal(decimal: number) {
        return Math.round(decimal);
    }

    return (
        <div>
            {label && <Label className="font-bold mb-2">{label}</Label>}
            <ColorPicker
                color={color}
                onChange={setColor}
                onChangeComplete={(color) => {
                    onChange(
                        `rgba(${getIntFromDecimal(color.rgb.r)}, ${getIntFromDecimal(color.rgb.g)}, ${getIntFromDecimal(color.rgb.b)}, ${color.rgb.a.toFixed(2)})`
                    );
                }}
            />
        </div>
    );
};
